
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';


import 'moment/locale/es';
import 'moment/locale/ca';
import 'moment/locale/en-ie';
import 'moment/locale/it';
import 'moment/locale/de';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/nl';
import 'moment/locale/fr';
import 'moment/locale/tr';
import 'moment/locale/zh-cn';
import 'moment/locale/gl';
import 'moment/locale/ar-ma';
import 'moment/locale/hu';
import 'moment/locale/cs';
import 'moment/locale/vi';
import 'moment/locale/sk';
import 'moment/locale/ro';
import 'moment/locale/pl';
import 'moment/locale/ja';

import ThemeProvider from '@synergycms_core/components/providers/themeProvider';
import ContentProvider from '@synergycms_core/components/providers/translateProvider';
import PopoverProvider from '@synergycms_core/components/providers/popoverProvider';
import App from './containers/app/App.jsx';
import store from '@synergycms_core/configureStore';


window.payformVersion = process.env.APP_VERSION;
console.log(process.env.APP_VERSION);

ReactDOM.render(
  <Provider store={store}>
    <ContentProvider value={{
      lang: window.lang_info.code,
      i18n: window.i18n
    }}>
      <ThemeProvider value={{
        appId: "payform",
        themeValues: (window.engine_sygy_data && window.engine_sygy_data.theme_values) || window.theme_values
      }}>
        <PopoverProvider>
          <App />
        </PopoverProvider>
      </ThemeProvider>
    </ContentProvider>
  </Provider>,
  document.getElementById('root')
);
